import React from "react";
import Paginations from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import { allBookingsListReducer } from "../slice";

function Report() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [status, setStatus] = useState();

  const handleShow = () => {
    setShow(!show);
  };
  const handlePage = (value) => {
    setPage(value);
  };

  const list = useSelector((store) => store.main.allBookingsList);

  const getList = useCallback(() => {
    setLoading(true);
    dispatch(
      allBookingsListReducer({
        page: page,
        limit: 12,
        orderStatus: "3",
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        setLoading(false);
      }
    });
  }, [dispatch, page, status]);

  useEffect(() => {
    getList();
  }, [getList]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
            <h3>My Reports</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetueradipiscing elit. Aenean
              commodo ligula eget dolor. Aenean massa.
            </p>
          </div>

          {loading ? (
            <Loader colorChange="colorChange" />
          ) : list?.data?.length > 0 ? (
            list?.data?.map((item, i) => (
              <div className="col-sm-12 col-md-6 col-lg-4 mb-3" key={i}>
                <div className="BookingBox">
                  <div className="row">
                    <div className="col-sm-3 col-md-3 col-lg-3">
                      <div className="">
                        <img
                          src="assets/images/PDF.png"
                          alt=""
                          className="reportIcon"
                        />
                      </div>
                    </div>
                    <div className="col-sm-9 col-md-9 col-lg-9">
                      <a
                        href={
                          item?.reportLink?.includes("http")
                            ? item?.reportLink
                            : ""
                        }
                        target="_blank"
                        className="mb-0 bookingTitle"
                      >
                        {item?.reportLink?.split("/").at(-1)}
                      </a>
                      <p className="mb-0 addresArea">
                        Order ID: <b>{item?.bookingId}</b>
                      </p>
                      <p className="mb-0 ps-3 position-relative addresArea">
                        <img
                          src="assets/images/locatelocation.png"
                          alt=""
                          className="pinIcon"
                        />{" "}
                        {item?.location}
                      </p>
                      <div className="d-flex justify-content-end align-items-center">
                        <span className="BookingPlan">
                          Plan:{item?.packageId?.packageName}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center">No Booking Report Found</div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-12 my-4">
            {list?.data?.length > 0 ? (
              <Paginations
                page={page}
                handlePage={handlePage}
                total={list?.count}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default Report;
